import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "ladenSection",
    "ballastSection",
    "ladenButton",
    "ballastButton"
  ];

  connect() {
    // derive initial state from which button is selected (fallback: laden)
    const startWithLaden = this.ladenButtonTargets.some(b => b.classList.contains("selected"));
    this.setMode(startWithLaden ? "laden" : "laden");
  }

  showLadenSection() { this.setMode("laden"); }
  showBallastSection() { this.setMode("ballast"); }

  setMode(mode) {
    const showLaden = mode === "laden";

    // toggle all sections that belong to this controller scope
    this.ladenSectionTargets.forEach(el => el.hidden = !showLaden);
    this.ballastSectionTargets.forEach(el => el.hidden = showLaden);

    // sync button states (support 1 or many buttons)
    this.ladenButtonTargets.forEach(b => b.classList.toggle("selected", showLaden));
    this.ballastButtonTargets.forEach(b => b.classList.toggle("selected", !showLaden));
  }
}
